import React from 'react';
import StepComponent from './StepComponent';
import TermsAndConditionsModalComponent from './TermsAndConditionsModal';
import { Box, Text, Row, Col, LinkButton } from 'tailwind-react-ui';

const HowWorksSection = () =>{

    const [showModal, setShowModal] = React.useState(false);

    return(
        <Box id="como-funciona" bg={'white'}>
            <Box text={['dark-gray', 'center']} className="landing-container">
                <Text is="h3" text={'center'} className="quicksand-bold tracking-wide" size="4xl" m={{b: 6}}>
                    ¿Cómo funciona?
                </Text>
                <Text is="p" text={'center'} className="quicksand-regular tracking-wide" size="2xl">
                    Haz de tu visita al Motel una experiencia única. <br/>
                    <b>Sígue estos pasos &#38; disfruta de 2 chelas con tu pareja.</b>
                </Text>
                <Box relative>
                    <div id="horizontal-dashed-line"/>
                    <div id="vertical-dashed-line"/>
                    <Row className="relative">
                        <Col m={{t: 6}} className="w-full sm:w-full md:w-1/3 lg:w-1/5">
                            <StepComponent 
                            src={'https://storage.googleapis.com/assets-sixtynite-com/chelas-gratis/motel.png'} 
                            alt={'visita-motel'}
                            step={'1'}
                            description="Visita un Motel de Sixtynite"/>
                        </Col>
                        <Col  m={{t: 6}} className="hidden lg:block lg:w-1/5"/>
                        <Col  m={{t: 6}} className="w-full sm:w-full md:w-1/3 lg:w-1/5">
                            <StepComponent 
                            src="https://storage.googleapis.com/assets-sixtynite-com/chelas-gratis/cupon.png" 
                            alt="cupon-de-descuento"
                            step={'2'}
                            description="Presenta el cupón en recepción"/>
                        </Col>
                        <Col  m={{t: 6}} className="hidden lg:block lg:w-1/5"/>
                        <Col m={{t: 6}} className="w-full sm:w-full md:w-1/3 lg:w-1/5">
                            <StepComponent 
                            src="https://storage.googleapis.com/assets-sixtynite-com/chelas-gratis/chela.png" 
                            alt="chelas-gratis"
                            step={'3'}
                            description="Disfruta de tus chelas bien frías"
                            active/>
                        </Col>
                    </Row>
                    <LinkButton 
                    style={{borderWidth: '0'}} 
                    className="quicksand-regular text-xl"
                    m={{t: 10}}
                    onClick={() => setShowModal(true)}>
                        Términos y Condiciones
                    </LinkButton>
                </Box>
            </Box>
            <TermsAndConditionsModalComponent showModal={showModal} setShowModal={(show) => setShowModal(show)}/>
        </Box>
    );
}

export default HowWorksSection;